var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-list-group',_vm._l((_vm.sess),function(session){return _c('sessionsListItem',{key:session.id,attrs:{"_sessionItem":session,"_participantID":_vm.participantID,"_toggle":_vm.toggle}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }